import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'user/list', method: 'POST', body: filter, token: token })
}
